export const firebaseConfig = {
    apiKey: "AIzaSyCgpK554GxIBQNt1NSOjZ4MM7-a_kTkzqc",
    authDomain: "premium-club-asu.firebaseapp.com",
    databaseURL: "https://premium-club-asu-default-rtdb.firebaseio.com",
    projectId: "premium-club-asu",
    storageBucket: "premium-club-asu.appspot.com",
    messagingSenderId: "671175602873",
    appId: "1:671175602873:web:8be5d405e2a9891369a168",
    measurementId: "G-4K0Z3N3EET"
}